import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const StorageIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M21.6 6.6C21.6 8.58823 17.302 10.2 12 10.2C6.69809 10.2 2.40002 8.58823 2.40002 6.6M21.6 6.6C21.6 4.61177 17.302 3 12 3C6.69809 3 2.40002 4.61177 2.40002 6.6M21.6 6.6V17.4C21.6 19.3882 17.302 21 12 21C6.69809 21 2.40002 19.3882 2.40002 17.4V6.6M21.6 12C21.6 13.9882 17.302 15.6 12 15.6C6.69809 15.6 2.40002 13.9882 2.40002 12"
        stroke="currentColor"
        strokeWidth="2"
      />
    </BaseIcon>
  );
};

StorageIcon.displayName = 'StorageIcon';
